module.exports = __webpack_public_path__ + "img/PureTrack_settings.f26052bf.png";